import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../api/axios";

export default function AdjuntarVisita() {
  const { id } = useParams(); // id del presupuesto
  const navigate = useNavigate();

  const [visitas, setVisitas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    cargarVisitas();
  }, []);

  const cargarVisitas = async () => {
    try {
      const r = await axios.get("/crm");
      setVisitas(r.data || []);
    } catch (err) {
      console.error(err);
      setError("Error cargando visitas");
    } finally {
      setLoading(false);
    }
  };

  const adjuntar = async (visitaId) => {
    try {
      await axios.put(`/presupuestos/${id}/visita`, { visitaId });
await cargarVisitas();


      navigate("/presupuestos");

    } catch (err) {
      console.error(err);
      alert("Error adjuntando presupuesto a la visita");
    }
  };

  if (loading) {
    return (
      <div style={page}>
        <div>Cargando visitas…</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={page}>
        <div>{error}</div>
      </div>
    );
  }

  return (
    <div style={page}>
      {/* CABECERA */}
      <h1 style={title}>
        📎 Adjuntar presupuesto a visita
      </h1>

      {/* LISTADO VISITAS */}
      {visitas.length === 0 ? (
        <div style={sub}>No hay visitas CRM</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {visitas.map((v) => (
            <div key={v.id} style={card}>
              <div>
                <div style={{ fontWeight: 800, fontSize: 16 }}>
                  {v.contacto || "Sin contacto"}
                </div>

                <div style={sub}>
                  Comercial: <strong>{v.comercial || "-"}</strong> ·{" "}
                  {v.ciudad || "-"}
                </div>
              </div>

{v.presupuestos && v.presupuestos.length > 0 && (
  <div style={{ fontSize: 12, opacity: 0.75, marginTop: 4 }}>
    📄 {v.presupuestos.length} presupuesto(s):{" "}
    <strong>
      {v.presupuestos.map(p => p.numero).join(", ")}
    </strong>
  </div>
)}




              <button
                className="glass-btn icon-btn"
                title="Adjuntar a esta visita"
                onClick={() => adjuntar(v.id)}
              >
                📎
              </button>
            </div>
          ))}
        </div>
      )}

      {/* ACCIONES */}
      <div style={{ marginTop: 20 }}>
        <button
          className="glass-btn"
          onClick={() => navigate(-1)}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}

/* ============================
   ESTILOS (MISMOS QUE CRM)
============================ */

const page = {
  padding: 20,
  minHeight: "100vh",
  background:
    "radial-gradient(circle at top left, #1f2937, #020617 60%, #000000)",
  color: "white"
};

const title = {
  fontSize: 22,
  fontWeight: 800,
  marginBottom: 16
};

const sub = {
  fontSize: 12,
  opacity: 0.75,
  marginTop: 4
};

const card = {
  background: "rgba(15,23,42,0.78)",
  borderRadius: 14,
  border: "1px solid rgba(148,163,184,0.30)",
  backdropFilter: "blur(10px)",
  boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
  padding: 14,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
};
